// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ExMz2","clouds":"styles_clouds__Gz+tv","whiteLine":"styles_whiteLine__3We4s"};